@if (item.show) {
  @if (item.url) {
    <a class="nav-link" [routerLink]="[item.url]" routerLinkActive="active"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}" matRipple>
      @if (item.icon) {
        <mat-icon class="nav-link-icon material-symbols-outlined">{{item.icon}}</mat-icon>
      }
      <span class="nav-link-title">{{item.title | translate}}</span>
      @if (item.badge) {
        <span class="nav-link-badge"
          [ngStyle]="{'background-color': '#F44336','color': 'white'}">
          {{item?.badge?.title ? item?.badge?.title : item?.badge}}
        </span>
      }
    </a>
  }
  @if (item.function) {
    <span class="nav-link" (click)="item.function()" matRipple>
      @if (item.icon) {
        <mat-icon class="nav-link-icon material-symbols-outlined">{{item.icon}}</mat-icon>
      }
      <span class="nav-link-title">{{item.title  | translate}}</span>
      @if (item.badge) {
        <span class="nav-link-badge"
          [ngStyle]="{'background-color': '#F44336','color': 'white'}">
          {{item?.badge?.title ? item?.badge?.title : item?.badge}}
        </span>
      }
    </span>
  }
}

